<template>
	<div class="w-full p-6 print:py-2">
		<h2
			class="form-title pb-6 text-2xl font-bold print:mb-3 print:border-b-2 print:border-slate-900 print:pt-2 print:pb-3 print:text-sm/0"
		>
			{{ t('plan.sectionTitle.personalIdentificationInfo') }}
		</h2>
		<section>
			<div
				class="section-grid-row grid grid-cols-2 *:w-full *:max-w-none *:px-1 *:pb-1"
			>
				<FormKit
					type="date"
					name="birthDate"
					:label="t('plan.birthDate')"
					:validation="[['date_between', pastDateMin, currentDate]]"
					validation-visibility="live"
					:help="
						t('plan.helpText.recorded', {
							helpTextLabel: t('plan.birthDate'),
						})
					"
				/>
				<FormKit
					type="mask"
					name="socialSecurityNumber"
					mode="select"
					mask="###-##-####"
					overlay
					:label="t('plan.ssn')"
					:help="
						t('plan.helpText.recorded', {
							helpTextLabel: t('plan.ssn'),
						})
					"
				/>
			</div>
			<BirthLocationForm :model="plan" />
		</section>
	</div>
</template>

<script setup lang="ts">
import BirthLocationForm from './BirthLocationForm.vue'
import type Plan from '@/classes/Plan'
import { usePresentationLocale } from '@/i18n'
import { FormKit } from '@formkit/vue'

const { t } = usePresentationLocale()

const pastDateMin = '1900-01-01' // Minimum date value
const currentDate = new Date().toISOString().split('T')[0] // Current date in YYYY-MM-DD format

defineProps<{
	plan: Plan
}>()
</script>
